import { render, staticRenderFns } from "./RedesignToggleButton.vue?vue&type=template&id=548131d4&scoped=true"
import script from "./RedesignToggleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignToggleButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignToggleButton.vue?vue&type=style&index=0&id=548131d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548131d4",
  null
  
)

export default component.exports